import { extrasConfig } from '@cocoonspace/shared/config/extras-config'
import { Trans } from 'next-i18next'
import type { DetailedHTMLProps, HTMLAttributes } from 'react'
import { cn } from '~/lib/utils'

export type ExtraTitleProps = {
	extraId: keyof typeof extrasConfig
	type?: 'base' | 'multiline' | 'noColor'
	className?: HTMLAttributes<any>['className']
} & DetailedHTMLProps<HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>

export const ExtraTitle = ({
	extraId,
	type = 'base',
	className,
}: ExtraTitleProps) => (
	<Trans
		parent='span'
		className={cn(`font-bold`, className)}
		i18nKey={`extras:${extraId}.title`}
		components={{
			strong:
				type === 'noColor' ? (
					<></>
				) : (
					<span style={{ color: extrasConfig[extraId]?.color }} />
				),
			br: type === 'multiline' ? <br /> : <></>,
		}}
	/>
)
